export const deletePushNotification = (payload: {id: number, mode?: string}) => ({
    type: "@saga/DELETE_PUSH_NOTIFICATION",
    payload
});